import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Language } from '../thi/thi-translations';
import { normalizeThiLang } from '../thi/thi-lang.util';
import { getLovableContactContent, ContactLovable } from '../thi/thi-lovable-contact.data';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
  curentLang = '';
  landingLang: Language = 'ar';
  c: ContactLovable = getLovableContactContent('ar');

  /** Software registration PDF under `src/assets/legal` */
  readonly registrationCertificatePdfUrl = 'assets/legal/software-registration-certificate.pdf';

  constructor(private spinner: NgxSpinnerService) {
    this.curentLang = localStorage.getItem('curentLang') || 'ar';
  }

  ngOnInit(): void {
    this.landingLang = normalizeThiLang(this.curentLang);
    this.c = getLovableContactContent(this.landingLang);
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
      window.scrollTo(0, 0);
    }, 400);
  }

  faqIconClass(kind: 'key' | 'bug' | 'help'): string {
    if (kind === 'key') return 'fa fa-key';
    if (kind === 'bug') return 'fa fa-bug';
    return 'fa fa-question-circle';
  }

  openEmail(): void {
    const subject = encodeURIComponent('Support Request - THI Invoices');
    const body = encodeURIComponent('Hello,\n\n');
    window.location.href = `mailto:support@thinvoices.com?subject=${subject}&body=${body}`;
  }

  openWhatsApp(): void {
    const message = encodeURIComponent('Hello, I need support...');
    window.open(`https://wa.me/972544585601?text=${message}`, '_blank', 'noopener,noreferrer');
  }
}
